// UserCards.js
import React from 'react';

const UserCards = ({ users, onEdit, onPromote, onDelete, getRoleName, getRoleBadgeClass }) => {
  return (
    <div className="p-6 bg-gray-50/50">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {users.length === 0 ? (
          <div className="col-span-full text-center py-12">
            <div className="flex flex-col items-center text-gray-500">
              <span className="text-6xl mb-4">😔</span>
              <span className="text-xl">No users found</span>
            </div>
          </div>
        ) : (
          users.map(user => (
            <div key={user._id} className="bg-white rounded-2xl p-6 border border-gray-200 hover:border-blue-300 transition-all duration-300 transform hover:-translate-y-2 hover:shadow-xl shadow-md">
              <div className="flex items-center space-x-4 mb-4">
                <div className="w-16 h-16 rounded-full bg-gradient-to-r from-blue-400 to-indigo-500 flex items-center justify-center text-white font-bold text-xl shadow-lg">
                  {user.firstName[0]}{user.lastName[0]}
                </div>
                <div className="flex-1">
                  <h3 className="text-gray-800 font-bold text-lg">{user.firstName} {user.lastName}</h3>
                  <p className="text-gray-600 text-sm">{user.email}</p>
                </div>
              </div>
              
              <div className="space-y-3 mb-6">
                <div className="flex justify-between items-center">
                  <span className="text-gray-600 text-sm font-medium">Role:</span>
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getRoleBadgeClass(user.profileLevel)}`}>
                    {getRoleName(user.profileLevel)}
                  </span>
                </div>
                
                {user.department && (
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600 text-sm font-medium">Department:</span>
                    <span className="text-gray-800 text-sm font-medium">{user.department}</span>
                  </div>
                )}
                
                {user.batch && (
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600 text-sm font-medium">Batch:</span>
                    <span className="text-gray-800 text-sm font-medium">{user.batch}</span>
                  </div>
                )}
                
                <div className="flex justify-between items-center">
                  <span className="text-gray-600 text-sm font-medium">Status:</span>
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    user.accountDeleted ? 'bg-red-100 text-red-800 border border-red-200' : 
                    user.validated ? 'bg-green-100 text-green-800 border border-green-200' : 
                    'bg-yellow-100 text-yellow-800 border border-yellow-200'
                  }`}>
                    {user.accountDeleted ? '🚫 Deleted' : user.validated ? '✅ Active' : '⏳ Pending'}
                  </span>
                </div>
              </div>
              
              <div className="flex space-x-2">
                <button 
                  className="flex-1 bg-blue-100 hover:bg-blue-200 text-blue-700 py-2 rounded-lg transition-all duration-200 border border-blue-200 hover:border-blue-300 text-sm font-semibold"
                  onClick={() => onEdit(user)}
                >
                  ✏️ Edit
                </button>
                <button 
                  className="flex-1 bg-green-100 hover:bg-green-200 text-green-700 py-2 rounded-lg transition-all duration-200 border border-green-200 hover:border-green-300 text-sm font-semibold"
                  onClick={() => onPromote(user)}
                >
                  🔄 Role
                </button>
                <button 
                  className="bg-red-100 hover:bg-red-200 text-red-700 px-3 py-2 rounded-lg transition-all duration-200 border border-red-200 hover:border-red-300 font-semibold"
                  onClick={() => onDelete(user._id)}
                >
                  🗑️
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default UserCards;
